import request from '@/utils/request'

// 查询在线用户列表
export function list(query) {
  return request({
    url: '/monitor/online/list',
    method: 'get',
    params: query
  })
}

// 强退用户
export function forceLogout(tokenId) {
  return request({
    url: '/monitor/online/' + tokenId,
    method: 'delete'
  })
}
// 强退用户根据用户id
export function forceLogoutByUserId(userId) {
  return request({
    url: '/monitor/online/force/' + userId,
    method: 'delete'
  })
}// 强退用户根据用户token
export function forceLogoutDevice(token) {
  return request({
    url: '/monitor/online/forceLogoutDevice/' + token,
    method: 'delete'
  })
}
